enum EmptyEnum {
	EMPTY_STATE = 'empty_state',
	EMPTY_SEARCH = 'empty_search',
}

enum CompleteProfileEnum {
	DV_VISUALIZOU_MODAL_AVISO = 'dv_visualizou_modal_aviso',
	DV_CLICK_IR_PARA_PERFIL = 'dv_click_ir_para_perfil',
	DV_CLICK_VOLTAR_PARA_INICIO = 'dv_click_voltar_para_inicio',
}

enum MyProfileEnum {
	CLICK_ALTERAR_BENEFICIARIO = 'click_alterar_beneficiario',
	CLICK_ALTERAR_LOCAL_DE_ATENDIMENTO = 'click_alterar_local_de_atendimento',
	CLICK_ALTERAR_CELULAR = 'click_alterar_celular',
	CLICK_ALTERAR_EMAIL = 'click_alterar_email',
	CLICK_ALTERAR_ENDERECO = 'click_alterar_endereco',
	CLICK_ALTERAR_DADOS_BANCARIOS = 'click_alterar_dados_bancarios',
	CLICK_ALTERAR_SENHA = 'click_alterar_senha',
	CLICK_CADASTRAR_CELULAR = 'click_cadastrar_celular',
	CLICK_CADASTRAR_EMAIL = 'click_cadastrar_email',
	CLICK_CADASTRAR_ENDERECO = 'click_cadastrar_endereco',
	CLICK_CADASTRAR_DADOS_BANCARIOS = 'click_cadastrar_dados_bancarios',
}

enum SelectionUserPlanEnum {
	SELECIONOU_PLANO = 'selecionou_plano',
	SELECIONOU_TITULAR = 'selecionou_titular',
	SELECIONOU_CIDADE_ATENDIMENTO = 'selecionou_cidade_atendimento',
	CONFIRMOU_USUARIO_E_CIDADE = 'confirmou_usuario_e_cidade',
}

enum GuideFilterEnum {
	APLICOU_FILTRO_ESTADO_SAUDE = 'aplicou_filtro_estado_saude',
	APLICOU_FILTRO_ESTADO_ODONTO = 'aplicou_filtro_estado_odonto',
	APLICOU_FILTRO_CIDADE_SAUDE = 'aplicou_filtro_cidade_saude',
	APLICOU_FILTRO_CIDADE_ODONTO = 'aplicou_filtro_cidade_odonto',
	APLICOU_FILTRO_SERVICO_SAUDE = 'aplicou_filtro_servico_saude',
	APLICOU_FILTRO_SERVICO_ODONTO = 'aplicou_filtro_servico_odonto',
	APLICOU_FILTRO_TIPO_REDE = 'aplicou_filtro_tipo_rede',
	APLICOU_FILTRO_ESPECIALIDADE_SAUDE = 'aplicou_filtro_especialidade_saude',
	APLICOU_FILTRO_ESPECIALIDADE_ODONTO = 'aplicou_filtro_especialidade_odonto_odonto',
	APLICOU_FILTRO_PRESTADOR_SAUDE = 'aplicou_filtro_prestador_saude',
	APLICOU_FILTRO_PRESTADOR_ODONTO = 'aplicou_filtro_prestador_odonto',
	APLICOU_FILTRO_BAIRRO = 'aplicou_filtro_bairro',
}

enum AppointmentBookingEnum {
	CLICK_AGENDAR_EXAME = 'click_agendar_exame',
	CLICK_AGENDAR_CONSULTA = 'click_agendar_consulta',
	CLICK_AGENDAR_TELECONSULTA = 'click_agendar_teleconsulta',
	CLICK_VER_MEUS_AGENDAMENTOS = 'click_ver_meus_agendamentos',
	CLICK_CONSULTA_PRESENCIAL = 'click_consulta_presencial',
	CLICK_PRONTO_ATENDIMENTO_DIGITAL = 'click_pronto_atendimento_digital',
	CLICK_TELECONSULTA = 'click_teleconsulta',
	CLICK_PULAR_SELECAO_PLANOS = 'click_pular_selecao_planos',
	ETAPA_ATUAL_AGENDAMENTO = 'etapa_atual_agendamento',
	CLICK_ALTERAR_INFORMACOES_AGENDAMENTO = 'click_alterar_informacoes_agendamento',
	CONFIRMOU_INFORMACOES = 'confirmou_informacoes',
	SELECIONOU_EXAME = 'selecionou_exame',
	SELECIONOU_ESPECIALIDADE = 'selecionou_especialidade',
	SELECIONOU_ESPECIALIDADE_MAIS_PROCURADA = 'selecionou_especialidade_mais_procurada',
	SELECIONOU_ESPECIALIDADE_TEXT = 'selecionou_especialidade_text',
	SELECIONOU_ESPECIALIDADE_SUGERIDA = 'selecionou_especialidade_sugerida',
	SELECIONOU_ESPECIALIDADE_SUGERIDA_TEXT = 'selecionou_especialidade_sugerida_text',
	SELECIONOU_UNIDADE_POR_LOCAL = 'selecionou_unidade_por_local',
	SELECIONOU_UNIDADE_POR_RAIO = 'selecionou_unidade_por_raio',
	SELECIONOU_UNIDADE_EXAME = 'selecionou_unidade_exame',
	SELECIONOU_TELECONSULTA = 'selecionou_teleconsulta',
	SELECIONOU_REDE_CREDENCIADA = 'selecionou_rede_credenciada',
	CLICK_DESCARTAR_AGENDAMENTO = 'click_descartar_agendamento',
	CANCELOU_AGENDAMENTO = 'cancelou_agendamento',
	ABANDONOU_AGENDAMENTO = 'abandonou_agendamento',
	ABANDONOU_SCRIPT_AGENDAMENTO = 'abandonou_script_de_agendamento',
	FECHOU_MODAL_ABANDONO_SCRIPT_AGENDAMENTO = 'fechou_modal_de_abandono_do_script_de_agendamento',
	DESISTIU_DE_ABANDONAR_SCRIPT_AGENDAMENTO = 'desistiu_de_abandonar_o_script_de_agendamento',
	REALIZOU_REMARCACAO_CONSULTA = 'realizou_remarcacao_consulta',
	REALIZOU_AGENDAMENTO_COM_SUCESSO = 'realizou_agendamento_com_sucesso',
	IR_PARA_MEU_PERFIL = 'ir_para_meu_perfil',
	PROCUROU_UNIDADES_PROXIMAS = 'procurou_unidades_proximas',
	ALTEROU_DISTANCIA = 'alterou_distancia',
	ALTEROU_DISTANCIA_POR_FILTRO = 'alterou_distancia_por_filtro',
	ABRIU_FILTRO_DISTANCIA = 'abriu_filtro_distancia',
	LIMPOU_FILTRO_DISTANCIA = 'limpou_filtro_distancia',
	APLICOU_FILTRO_DISTANCIA = 'aplicou_filtro_distancia',
	VISUALIZOU_ORIENTACOES_EXAME = 'visualizou_orientacoes_exame',
	CONFIRMOU_ORIENTACOES_EXAME = 'confirmou_orientacoes_exame',
	VISUALIZOU_PROFISSIONAL_DISPONIVEL = 'visualizou_profissional_disponivel',
	SELECIONOU_HORARIO_DISPONIVEL = 'selecionou_horario_disponivel',
	CLICK_BUSCAR_UNIDADES_PROXIMAS = 'click_buscar_unidades_proximas',
	CLICK_FALAR_COM_ATENDIMENTO_AGENDAMENTO = 'click_falar_com_atendimento_agendamento',
	CLICK_LIGAR_AGENDAMENTO = 'click_ligar_agendamento',
	CLICK_ALTERAR_LOCAL_ATENDIMENTO_AGENDAMENTO = 'click_alterar_local_atendimento_agendamento',
	CLICK_VOLTAR_AGENDAMENTO = 'click_voltar_agendamento',
	CLICK_VOLTAR_SCRIPT = 'click_voltar_script',
	CLICK_FECHAR_SCRIPT = 'click_fechar_script',
	CLICK_ACESSAR_CONCIERGE = 'click_acessar_concierge',
	CLICK_CONFIRMAR_CONTINUAR = 'click_confirmar_continuar_',
	CLICK_BUSCAR_ESPECIALIDADE = 'click_buscar_especialidade',
	CLICK_FILTRAR_ESPECIALIDADE = 'click_filtrar_especialidade_',
	SELECIONOU_ESTADO = 'selecionou_estado_',
	SELECIONOU_CIDADE = 'selecionou_cidade_',
	CLICK_VER_MAPA_AGENDAMENTO = 'click_ver_mapa_agendamento_',
	CLICK_AGENDAR_UNIDADE = 'click_agendar_unidade_',
	CLICK_LIGAR_UNIDADE = 'click_ligar_unidade_',
	CLICK_DETALHES_UNIDADE = 'click_detalhes_unidade_',
	CLICK_ALTERAR_LOCALIZACAO = 'click_alterar_localizacao',
	CLICK_AGENDAR_EXAME_UNIDADE = 'click_agendar_exame_unidade_',
	VISUALIZOU_MODAL_ABANDONO = 'visualizou_modal_abandono',
	CLICK_PROXIMO_A_MIM = 'click_proximo_a_mim',
	CLICK_ESCOLHER_LOCAL = 'click_escolher_local',
	NOME_STEP = 'nome_step',
	CLICK_NAO_ENCONTREI_BAIRRO_DESEJADO = 'click_nao_encontrei_bairro_desejado',
	CLICK_AVANCAR_SELECAO_BAIRROS = 'click_avancar_selecao_bairros',
	CLICK_ALTERAR_LOCAL_DE_ATENDIMENTO = 'click_alterar_local_de_atendimento',
	CLICK_DATAS_MAIS_PROXIMAS = 'click_datas_mais_proximas',
	CLICK_PULAR_OVERBOOKING = 'click_pular_overbooking',
	VISUALIZOU_MODAL_ALTERACAO_ESPECIALIDADE = 'visualizou_modal_alteracao_especialidade',
	CLICK_CANCELAR_MODAL_ALTERACAO_ESPECIALIDADE = 'click_cancelar_modal_alteracao_especialidade',
	CLICK_CONFIRMAR_MODAL_ALTERACAO_ESPECIALIDADE = 'click_confirmar_modal_alteracao_especialidade',
	CLICK_ASSISTIR_VIDEO_TELEMEDICINA = 'click_assistir_video_telemedicina',
	CLICK_AGENDAR_SEM_AGENDAMENTOS_PROXIMOS = 'click_agendar_sem_agendamentos_proximos',
	VISUALIZOU_MODAL_NAO_ENCONTREI_BAIRRO_DESEJADO = 'visualizou_modal_nao_encontrei_bairro_desejado',
	CLICK_FECHAR_MODAL_NAO_ENCONTREI_BAIRRO_DESEJADO = 'click_fechar_modal_nao_encontrei_bairro_desejado',
	CLICK_CONSULTAR_REDE_ATENDIMENTO = 'click_consultar_rede_atendimento',
	CLICK_FALAR_COM_ATENDIMENTO_ONLINE = 'click_falar_com_atendimento_online',
	VISUALIZOU_MODAL_ALTERAR_LOCAL_DE_ATENDIMENTO = 'visualizou_modal_alterar_local_de_atendimento',
	CLICK_CANCELAR_MODAL_ALTERAR_LOCAL_DE_ATENDIMENTO = 'click_cancelar_modal_alterar_local_de_atendimento',
	CLICK_CONFIRMAR_MODAL_ALTERAR_LOCAL_DE_ATENDIMENTO = 'click_confirmar_modal_alterar_local_de_atendimento',
	CLICK_FECHAR_MODAL_ALTERAR_LOCAL_DE_ATENDIMENTO = 'click_fechar_modal_alterar_local_de_atendimento',
	CLICK_LOCALIZACAO_SELECIONADA_RECENTEMENTE = 'click_localizacao_selecionada_recentemente',
	CLICK_NAO_ENCONTREI_ESTADO_DESEJADO = 'click_nao_encontrei_estado_desejado',
	VISUALIZOU_NAO_ENCONTREI_ESTADO_DESEJADO = 'visualizou_modal_nao_encontrei_estado_desejado',
	CLICK_FECHAR_MODAL_NAO_ENCONTREI_ESTADO = 'click_fechar_modal_nao_encontrei_estado',
	CLICK_CONSULTAR_REDE_MODAL_NAO_ENCONTREI_ESTADO = 'click_consultar_rede_modal_nao_encontrei_estado',
	CLICK_FALAR_COM_ATENDIMENTO_MODAL_NAO_ENCONTREI_ESTADO = 'click_falar_com_atendimento_modal_nao_encontrei_estado',
	CLICK_NAO_ENCONTREI_CIDADE_DESEJADA = 'click_nao_encontrei_cidade_desejada',
	VISUALIZOU_MODAL_NAO_ENCONTREI_CIDADE = 'visualizou_modal_nao_encontrei_cidade',
	CLICK_FECHAR_MODAL_NAO_ENCONTREI_CIDADE = 'click_fechar_modal_nao_encontrei_cidade',
	CLICK_CONSULTAR_REDE_MODAL_NAO_ENCONTREI_CIDADE = 'click_consultar_rede_modal_nao_encontrei_cidade',
	CLICK_FALAR_COM_ATENDIMENTO_MODAL_NAO_ENCONTREI_CIDADE = 'click_falar_com_atendimento_modal_nao_encontrei_cidade',
	CLICK_SABER_MAIS_DESCRICAO_ESPECIALIDADE = 'click_saber_mais_descricao_especialidade',
	VISUALIZOU_CARD_INADIMPLENCIA = 'visualizou_card_inadimplencia',
	CLICK_VOLTAR_TELA_INICIAL_CARD_INADIMPLENCIA = 'click_voltar_tela_inicial_card_inadimplencia',
	CLICK_FALAR_COM_ATENDIMENTO_CARD_INADIMPLENCIA = 'click_falar_com_atendimento_card_inadimplencia',
	VISUALIZOU_MODAL_AVISO_RETORNO_SCRIPT = 'visualizou_modal_aviso_retorno_script',
	CLICK_FECHAR_MODAL_AVISO_RETORNO_SCRIPT = 'click_fechar_modal_aviso_retorno_script',
	CLICK_CONFIRMAR_MODAL_AVISO_RETORNO_SCRIPT = 'click_confirmar_modal_aviso_retorno_script',
	CLICK_CANCELAR_MODAL_AVISO_RETORNO_SCRIPT = 'click_cancelar_modal_aviso_retorno_script',
	VISUALIZOU_MODAL_PRESENCIAL_AO_DIGITAL = 'visualizou_modal_presencial_ao_digital',
	CLICK_NAVEGAR_TELEMEDICINA_PRESENCIAL_AO_DIGITAL = 'click_navegar_telemedicina_presencial_ao_digital',
	CLICK_MANTER_AGENDAMENTO_PRESENCIAL_AO_DIGITAL = 'click_manter_agendamento_presencial_ao_digital',
}

enum BookingScheduledEnum {
	CLICK_CANCELAR_CONSULTA = 'click_cancelar_consulta',
	CLICK_REMARCAR_CONSULTA = 'click_remarcar_consulta',
	CLICK_CONFIRMAR_PRESENCA = 'click_confirmar_presenca',
	CONFIRMOU_PRESENCA_COM_SUCESSO = 'confirmou_presenca_com_sucesso',
	CLICK_CONFIRMAR_AGENDAMENTO = 'click_confirmar_agendamento',
	CLICK_CONFIRMAR_AGENDAMENTO_EXAME = 'click_confirmar_agendamento_exame',
	VISUALIZOU_MODAL_CANCELAR_AGENDAMENTO = 'visualizou_modal_cancelar_agendamento',
	CLICK_FECHAR_ICONE_MODAL_CANCELAR_AGENDAMENTO = 'click_fechar_modal_cancelar_agendamento',
	CLICK_FECHAR_BOTAO_MODAL_CANCELAR_AGENDAMENTO = 'click_fechar_botao_modal_cancelar_agendamento',
	CLICK_CONFIRMAR_CANCELAR_AGENDAMENTO = 'click_confirmar_cancelar_agendamento',
}

enum BookingScriptFlowEnum {
	CLICK_PROSSEGUIR_COM_SUGESTAO = 'click_prosseguir_com_sugestao',
	CLICK_INICIAR_CHAT_SUGESTAO_AGENDAMENTO = 'click_iniciar_chat_sugestao_agendamento',
	CLICK_FECHAR_AGENDAMENTO_SUGERIDO = 'click_fechar_agendamento_sugerido',
	VISUALIZOU_SUGESTAO_AGENDAMENTO = 'visualizou_sugestao_agendamento',
}
enum BookingProcessSuccessEnum {
	ENCONTROU_HORARIOS_DISPONIVEIS = 'encontrou_horarios_disponiveis',
	ACESSOU_ETAPA_REVISAO_AGENDAMENTO = 'acessou_etapa_revisao_agendamento',
}

enum MotorV2Enums {
	V2_ERRO_AGENDAMENTO = 'v2_erro_agendamento',
	V2_CLICK_CTA_ERRO_AGENDAMENTO = 'v2_click_cta_erro_agendamento',
	V2_ERRO_HORARIO = 'v2_erro_horario',
	V2_CLICK_CTA_ERRO_HORARIO = 'v2_click_cta_erro_horario',
	V2_MODAL_ERRO_GENERICO = 'v2_modal_erro_generico',
	V2_CLICK_CTA_ERRO_GENERICO = 'v2_click_cta_erro_generico',
}
enum FinishWithoutCompleteFlowEnum {
	APENAS_TELEFONE_DISPONIVEL = 'apenas_telefone_disponivel',
	POSSUI_CONSULTA_EXISTENTE_ESPECIALIDADE = 'possui_consulta_existente_especialidade',
	NECESSARIO_ENCAMINHAMENTO_MEDICO = 'necessario_encaminhamento_medico',
	SEM_UNIDADES_AGENDAMENTO_DISPONIVEL = 'sem_unidades_agendamento_disponivel',
	SEM_HORARIOS_AGENDAMENTO_DISPONIVEL = 'sem_horarios_agendamento_disponivel',
	SEM_ESTADO_DISPONIVEL = 'sem_estado_disponivel',
	SEM_ESPECIALIDADE_DISPONIVEL = 'sem_especialidade_disponivel',
	SEM_LOCALIDADE_DISPONIVEL = 'sem_localidade_disponivel',
	SEM_PROFISSIONAL_DISPONIVEL = 'sem_profissional_disponivel',
	SEM_CIDADE_DISPONIVEL = 'sem_cidade_disponivel',
	SEM_BAIRRO_DISPONIVEL = 'sem_bairro_disponivel',
	SEM_UNIDADES_AGENDAMENTO_ENCONTRADA = 'sem_unidades_agendamento_encontrada',
	SEM_HORARIOS_AGENDAMENTO_ENCONTRADO = 'sem_horarios_agendamento_encontrado',
	SEM_ESPECIALIDADE_ENCONTRADA = 'sem_especialidade_encontrada',
	SEM_ESTADO_ENCONTRADO = 'sem_estado_encontrado',
	SEM_PROFISSIONAL_ENCONTRADO = 'sem_profissional_encontrado',
	SEM_BAIRRO_ENCONTRADO = 'sem_bairro_encontrado',
	SEM_CIDADE_ENCONTRADA = 'sem_cidade_encontrada',
	SEM_FRANQUIA_ENCONTRADA = 'sem_franquia_encontrada',
	SEM_AUTORIZACAO_ENCONTRADA = 'sem_autorizacao_encontrada',
	SEM_LOCALIDADE_ENCONTRADA = 'sem_localidade_encontrada',
	SEM_PROCEDIMENTO_ENCONTRADO = 'sem_procedimento_encontrado',
	SEM_REEMBOLSO_ENCONTRADO = 'sem_reembolso_encontrado',
	SEM_PROTOCOLO_ENCONTRADO = 'sem_protocolo_encontrado',
}

enum FiveStarsEnum {
	CLICK_X_AVALIACAO = 'click_x_avaliacao',
	CLICK_ATENDIMENTO_ANTERIOR = 'click_atendimento_anterior',
	CLICK_PROXIMO_ATENDIMENTO = 'click_proximo_atendimento',
	CLICK_AVALIAR_ATENDIMENTO = 'click_avaliar_atendimento',
	CLICK_NAO_QUERO_AVALIAR = 'click_nao_quero_avaliar',
	CLICK_VOLTAR_E_REALIZAR_AVALIACAO = 'click_voltar_e_realizar_avaliacao',
	CLICK_DESCARTAR_AVALIACAO = 'click_descartar_avaliacao',
	CLICK_ESTRELAS_AVALIACAO = 'click_estrelas_avaliacao',
	ETAPAS_5_ESTRELAS = 'etapas_5_estrelas',
	AVALIACAO_PERGUNTAS = 'avaliacao_perguntas',
	CLICK_AVANCAR_AVALIACAO = 'click_avancar_avaliacao',
	CLICK_VOLTAR_AVALIACAO = 'click_voltar_avaliacao',
	REALIZOU_AVALIACAO_COM_SUCESSO = 'realizou_avaliacao_com_sucesso',
	QUANTIDADE_PERGUNTAS = 'quantidade_perguntas',
	NUMERO_DE_AVALIACOES = 'numero_de_avaliacoes',
	VISUALIZOU_MODAL_AVALIACOES = 'visualizou_modal_avaliacoes',
	TIMER_INICIO_MODAL_5_ESTRELAS = 'timer_inicio_modal_5_estrelas',
	VISUALIZOU_PERGUNTA = 'visualizou_pergunta',
	CONTAINER_PERGUNTAS = 'container_perguntas',
}

enum AutoSolEnum {
	AS_CLICK_NOVA_SOLICITACAO_HISTORICO = 'as_click_nova_solicitacao_historico',
	AS_CLICK_NOVA_SOLICITACAO_ANDAMENTO = 'as_click_nova_solicitacao_andamento',
	AS_CLICK_SAIBA_MAIS = 'as_click_saiba_mais',
	AS_CLICK_ALTERAR_PLANO = 'as_click_alterar_plano',
	AS_CLICK_FILTRO_LIBERADO = 'as_click_filtro_liberado',
	AS_CLICK_FILTRO_PENDENTE = 'as_click_filtro_pendente',
	AS_CLICK_FILTRO_INDEFERIDO = 'as_click_filtro_indeferido',
	AS_CLICK_FILTRO_TODOS = 'as_click_filtro_todos',
	AS_CLICK_COPIAR_SENHA = 'as_click_copiar_senha',
	AS_CLICK_DOWNLOAD = 'as_click_download',
	AS_CLICK_ENVIAR_SOLICITACAO = 'as_click_enviar_solicitacao',
	AS_VISUALIZOU_MODAL_CONCLUSAO = 'as_visualizou_modal_conclusao',
	AS_CLICK_COPIAR_PROTOCOLO = 'as_click_copiar_protocolo',
	AS_CLICK_ABRIR_ANEXO = 'as_click_abrir_anexo',
	AS_CLICK_ADICIONAR_ANEXO = 'as_click_adicionar_anexo',
	AS_CLICK_FILTRO_TODOS_ANDAMENTO = 'as_click_filtro_todos_andamento',
	AS_CLICK_FILTRO_REGISTRADO = 'as_click_filtro_registrado',
	AS_CLICK_FILTRO_PENDENTE_ANDAMENTO = 'as_click_filtro_pendente_andamento',
	AS_CLICK_FILTRO_CONCLUIDO = 'as_click_filtro_concluido',
	AS_CLICK_FILTRO_EM_ANALISE = 'as_click_filtro_analise',
	AS_CLICK_VER_DETALHES = 'as_click_ver_detalhes',
	AS_CLICK_ABA_HISTORICO = 'as_click_aba_historico',
	AS_CLICK_ABA_EM_ANDAMENTO = 'as_click_aba_em_andamento',
	AS_VISUALIZOU_MODAL_DESCARTE = 'as_visualizou_modal_descarte',
	AS_CLICK_CANCELAR_DESCARTE = 'as_click_cancelar_descarte',
	AS_CLICK_CONFIRMAR_DESCARTE = 'as_click_confirmar_descarte',
	AS_CLICK_FECHAR_MODAL_DESCARTE = 'as_click_fechar_modal_descarte',
	AS_CLICK_OVERLAY_CONCLUSAO = 'as_click_overlay_conclusao',
	AS_CLICK_FAZER_NOVA_SOLICITACAO = 'as_click_fazer_nova_solicitacao',
	AS_CLICK_SOLICITACOES_ANDAMENTO = 'as_click_solicitacoes_andamento',
	AS_VISUALIZOU_MODAL_HORARIO = 'as_visualizou_modal_horario',
	AS_CLICK_FECHAR_MODAL_HORARIO = 'as_click_fechar_modal_horario',
	AS_CLICK_BTN_ENTENDI = 'as_click_btn_entendi',
	AS_CLICK_VER_MAIS = 'as_click_ver_mais',
	AS_CLICK_VER_MEUS_AGENDAMENTOS = 'as_click_ver_meus_agendamentos',
	CLICK_ACESSAR_AUTOSOL_SAUDE = 'click_acessar_autosol_saude',
	CLICK_FECHAR_AUTOSOL_SAUDE = 'click_fechar_autosol_saude',
	CLICK_SIM_PREFERENCIA_AUTOSOL_SAUDE = 'click_sim_preferencia_autosol_saude',
	CLICK_NAO_PREFERENCIA_AUTOSOL_SAUDE = 'click_nao_preferencia_autosol_saude',
	CLICK_CONTINUAR_DETALHES_DA_SOLICITACAO = 'click_continuar_detalhes_da_solicitacao',
	CLICK_BUSCAR_PRESTADORES = 'click_buscar_prestadores',
	CLICK_FECHAR_DRAWER_PRESTADORES = 'click_fechar_drawer_prestadores',
	CLICK_CONTINUAR_BUSCA_PRESTADORES = 'click_continuar_busca_prestadores',
	CLICK_ADICIONAR_ANEXO_AUTOSOL = 'click_adicionar_anexo_autosol',
	VISUALIZOU_MODAL_DE_ANEXO_AUTOSOL = 'visualizou_modal_de_anexo_autosol',
	CLICK_ENTENDI_MODAL_DE_ANEXO_AUTOSOL = 'click_entendi_modal_de_anexo_autosol',
	CLICK_FECHAR_MODAL_DE_ANEXO_AUTOSOL = 'click_fechar_modal_de_anexo_autosol',
	VISUALIZOU_MODAL_DE_CONCLUSAO_AUTOSOL = 'visualizou_modal_de_conclusao_autosol',
	CLICK_VOLTAR_PARA_CONCLUSAO_AUTOSOL = 'click_voltar_para_conclusao_autosol',
	CLICK_VOLTAR_HOME_AUTOSOL = 'click_voltar_home_autosol',
	CLICK_FECHAR_AUTOSOL = 'click_fechar_autosol',
	CLICK_VER_MAIS_HISTORICO_AUTOSOL = 'click_ver_mais_historico_autosol',
	CLICK_VER_REDE_DE_ATENDIMENTO_AUTOSOL = 'click_ver_rede_de_atendimento_autosol',
	CLICK_VER_IMAGEM_EXEMPLO_AUTOSOL = 'click_ver_imagem_exemplo_autosol',
	CLICK_ENTENDI_INFOS_AUTOSOL = 'click_entendi_infos_autosol',
	CLICK_REDE_DE_ATENDIMENTO_AUTOSOL = 'click_rede_de_atendimento_autosol',
	CLICK_AGENDAR_EXAME_AUTOSOL = 'click_agendar_exame_autosol',
	CLICK_FILTRO_AUTOSOL = 'click_filtro_autosol',
	CLICK_FECHAR_DRAWER_TRILHA_AUTOSOL = 'click_fechar_drawer_trilha_autosol',
	CLICK_BOTAO_FECHAR_DRAWER_AUTOSOL = 'click_botao_fechar_drawer_autosol',
	CLICK_CONFIRMAR_E_CONTINUAR_AUTOSOL = 'click_confirmar_e_continuar_autosol',
	CLICK_BOTAO_ALTERAR_DADOS_AUTOSOL = 'click_botao_alterar_dados_autosol',
	CLICK_ESCOLHER_LOCAL_AUTOSOL = 'click_escolher_local_autosol',
	CLICK_REMOVER_ARQUIVO_ANEXO_AUTOSOL = 'click_remover_arquivo_anexo_autosol',
	CLICK_REMOVER_ANEXO_AUTOSOL = 'click_remover_anexo_autosol_',
	CLICK_SELECIONAR_PRESTADOR_AUTOSOL = 'click_selecionar_prestador_autosol_',
	CLICK_REMOVER_PRESTADOR_AUTOSOL = 'click_remover_prestador_autosol_',
	VISUALIZOU_MODAL_DE_REMOVER_ANEXO_AUTOSOL = 'visualizou_modal_de_remover_anexo_autosol',
	CLICK_FECHAR_MODAL_DE_REMOVER_ANEXO_AUTOSOL = 'click_fechar_modal_de_remover_anexo_autosol',
	CLICK_CANCELAR_MODAL_DE_REMOVER_ANEXO_AUTOSOL = 'click_cancelar_modal_de_remover_anexo_autosol',
	CLICK_CONFIRMAR_MODAL_DE_REMOVER_ANEXO_AUTOSOL = 'click_confirmar_modal_de_remover_anexo_autosol',
	VISUALIZOU_ERRO_ADICIONAR_UM_ARQUIVO_AUTOSOL = 'visualizou_erro_adicionar_um_arquivo_autosol',
	CLICK_FECHAR_FILTRO_AUTOSOL = 'click_fechar_filtro_autosol',
	CLICK_LIMPAR_FILTRO_AUTOSOL = 'click_limpar_filtro_autosol',
	CLICK_APLICAR_FILTRO_AUTOSOL = 'click_aplicar_filtro_autosol',
	CLICK_ALTERAR_LOCALIZACAO_AUTOSOL = 'click_alterar_localizacao_autosol',
}

enum NetworkEnum {
	CLICK_REDE_ASSISTENCIAL = 'click_rede_assistencial',
	CLICK_VER_DETALHES = 'click_ver_detalhes',
	CLICK_GUIA_AGENDAR_CONSULTA = 'click_guia_agendar_consulta',
	CLICK_GUIA_AGENDAR_TELECONSULTA = 'click_guia_agendar_teleconsulta',
	CLICK_VER_CONTATO_REDE_CREDENCIADA = 'click_ver_contato_rede_credenciada',
}

enum ServicesTaggingEnum {
	CLICK_ACESSAR_PORTAL_IR = 'click_acessar_portal_ir',
	CLICK_APLICAR_FILTRO_IR = 'click_aplicar_filtro_ir',
	CLICK_LIMPAR_FILTRO_IR = 'click_limpar_filtro_ir',
	CLICK_IR_ANO = 'click_ir_ano_',
	CLICK_DEMOSTRATIVO_IR = 'click_demostrativo_ir',
	CLICK_BAIXAR_DEMOSTRATIVO_IR = 'click_baixar_demostrativo_ir',
	CLICK_CENTRAL_DE_SERVICOS = 'click_central_de_servicos',
	CLICK_CONSULTA_DE_PROTOCOLOS = 'click_consulta_de_protocolos',
	CLICK_BENEFICIOS = 'click_beneficios',
	CLICK_PRECISA_DE_AJUDA = 'click_precisa_de_ajuda',
	CLICK_MEU_PERFIL = 'click_meu_perfil',
	CLICK_CARTEIRINHAS = 'click_carteirinhas',
	CLICK_SALVAR_IMAGEM_CARTEIRINHAS = 'click_salvar_imagem_carteirinhas',
	CLICK_EXTRATO_DE_CO_PARTICIPACAO = 'click_extrato_de_co_participacao',
	CLICK_ALTERAR_DATA_DE_VENCIMENTO = 'click_alterar_data_de_vencimento',
	CLICK_ADESAO_BOLETO_DIGITAL = 'click_adesao_boleto_digital',
	CLICK_RESULTADO_DE_EXAMES = 'click_resultado_de_exames',
	CLICK_CONCIERGE = 'click_concierge',
}

enum RefundTaggingEnum {
	CLICK_ACESSAR_REEMBOLSO_SAUDE = 'click_acessar_reembolso_saude',
	CLICK_SOLICITAR_REEMBOLSO = 'click_solicitar_reembolso',
	CLICK_CONTINUAR_SOLICITACAO_REEMBOLSO = 'click_continuar_solicitacao_reembolso',
	CLICK_PESQUISAR_PROFISSIONAL = 'click_pesquisar_profissional',
	CLICK_SELECIONAR_PROFISSIONAL = 'click_selecionar_profissional',
	CLICK_CONTINUAR_STEP = 'click_continuar_step',
	CLICK_VOLTAR_STEP_SOLICITACAO_REEMBOLSO = 'click_voltar_step_solicitacao_reembolso',
	CLICK_FECHAR_SOLICITACAO_REEMBOLSO = 'click_fechar_solicitacao_reembolso',
	VISUALIZOU_MODAL_CONCLUSAO_SOLICITACAO = 'visualizou_modal_conclusao_solicitacao',
	CLICK_VOLTAR_PARA_TELA_INICIAL_SOLICITACAO = 'click_voltar_para_tela_inicial_solicitacao',
	CLICK_PROSSEGUIR_PARA_ANEXOS = 'click_prosseguir_para_anexos',
	CLICK_ADICIONAR_ARQUIVOS_REEMBOLSO = 'click_adicionar_arquivos_reembolso',
	ADICIONOU_ARQUIVO = 'adicionou_arquivo_reembolso_',
	CLICK_PROSSEGUIR_PARA_REVISAO_REEMBOLSO = 'click_prosseguir_para_revisao_reembolso',
	CLICK_FINALIZAR_SOLICITACAO_REEMBOLSO = 'click_finalizar_solicitacao_reembolso',
	CLICK_CADASTRAR_OUTRA_SOLICITACAO = 'click_cadastrar_outra_solicitacao',
	CLICK_ALTERAR_DADOS_PRESTADOR = 'click_alterar_dados_prestador',
	CLICK_ALTERAR_DADOS_PACIENTE = 'click_alterar_dados_paciente',
	CLICK_ALTERAR_DOCUMENTO_FISCAL = 'click_alterar_documento_fiscal',
	CLICK_ALTERAR_ANEXOS = 'click_alterar_anexos',
	CLICK_ABRIR_CALENDARIO_CONSULTA_REEMBOLSO = 'click_abrir_calendario_consulta_reembolso',
	CLICK_FECHAR_CALENDARIO_CONSULTA_REEMBOLSO = 'click_fechar_calendario_consulta_reembolso',
	CLICK_LIMPAR_DATA_CONSULTA_REEMBOLSO = 'click_limpar_data_consulta_reembolso',
	CLICK_CONFIRMAR_DATA_CONSULTA_REEMBOLSO = 'click_confirmar_data_consulta_reembolso',
	CLICK_VER_SOLICITACAO_CONSULTA_REEMBOLSO = 'click_ver_solicitacao_consulta_reembolso',
	CLICK_CONTINUAR_PARA_ENVIO_DE_DOCUMENTOS = 'click_continuar_para_envio_de_documentos',
	VISUALIZOU_MODAL_IMPOSSIVEL_ADICIONAR_DOCUMENTOS = 'visualizou_modal_impossivel_adicionar_documentos',
	CLICK_FECHAR_MODAL_IMPOSSIVEL_ADICIONAR_DOCUMENTOS = 'click_fechar_modal_impossivel_adicionar_documentos',
	CLICK_VOLTAR_PARA_TELA_INICIAL_MODAL_IMPOSSIVEL_ADICIONAR_DOCUMENTOS = 'click_voltar_para_tela_inicial_modal_impossivel_adicionar_documentos',
	CLICK_VOLTAR_PARA_ENVIO_MODAL_IMPOSSIVEL_ADICIONAR_DOCUMENTOS = 'click_voltar_para_envio_modal_impossivel_adicionar_documentos',
	CLICK_LI_E_CONCORDO_DADOS_COMPLEMENTARES = 'click_li_e_concordo_dados_complementares',
	CLICK_CONTINUAR_PARA_PREVIA_REEMBOLSO = 'click_continuar_para_previa_reembolso',
	CLICK_ALTERAR_DADOS_PACIENTE_PREVIA = 'click_alterar_dados_paciente_previa',
	CLICK_ALTERAR_ANEXOS_PREVIA = 'click_alterar_anexos_previa',
	CLICK_SOLICITAR_PREVIA_REEMBOLSO = 'click_solicitar_previa_reembolso',
	CLICK_CONSULTAR_PREVIA_REEMBOLSO = 'click_consultar_previa_reembolso',
	CLICK_PESQUISAR_CONSULTA_PREVIA_REEMBOLSO = 'click_pesquisar_consulta_previa_reembolso',
	VISUALIZOU_MODAL_ERRO_PREVIA_REEMBOLSO = 'visualizou_modal_erro_previa_reembolso',
	CLICK_VOLTAR_PARA_PAGINA_INICIAL_PREVIA = 'click_voltar_para_pagina_inicial_previa',
	CLICK_TENTAR_NOVAMENTE_PREVIA = 'click_tentar_novamente_previa',
	CLICK_PESQUISAR_CONSULTAR_REEMBOLSO = 'click_pesquisar_consultar_reembolso',
	CLICK_VER_LISTA_DE_DOCUMENTOS = 'click_ver_lista_de_documentos',
	CLICK_VER_COMUNICADO_ANS = 'click_ver_comunicado_ans',
	CLICK_O_QUE_PODE_SER_REEMBOLSADO = 'click_o_que_pode_ser_reembolsado',
	CLICK_VISUALIZAR_TABELA_REEMBOLSO = 'click_visualizar_tabela_reembolso',
	CLICK_CONTINUAR_PARA_REEMBOLSO = 'click_continuar_para_reembolso',
	CLICK_DIV_UPLOAD_ARQUIVOS = 'click_div_upload_arquivos',
	CLICK_CONTINUAR_PARA_ENVIO_DE_DOCUMENTOS_COMPLEMENTARES = 'click_continuar_para_envio_de_documentos_complementares',
	DIGITOU_NUMERO_REEMBOLSO_ENVIO_DE_DOCUMENTOS_COMPLEMENTARES = 'digitou_numero_reembolso_envio_de_documentos_complementares',
	ENCONTROU_REEMBOLSO_PARA_ENVIO_DE_DOCUMENTOS_COMPLEMENTARES = 'encontrou_reembolso_para_envio_de_documentos_complementares',
	CLICK_PROSSEGUIR_PARA_ANEXOS_ENVIO_DE_DOCUMENTOS_COMPLEMENTARES = 'click_prosseguir_para_anexos_envio_de_documentos_complementares',
	CLICK_ADICIONAR_ARQUIVOS_ENVIO_DE_DOCUMENTOS_COMPLEMENTARES = 'click_adicionar_arquivos_envio_de_documentos_complementares',
	CLICK_PROSSEGUIR_PARA_REVISAO_ENVIO_DE_DOCUMENTOS_COMPLEMENTARES = 'click_prosseguir_para_revisao_envio_de_documentos_complementares',
	CLICK_FINALIZAR_ENVIO_DE_DOCUMENTOS_COMPLEMENTARES = 'click_finalizar_envio_de_documentos_complementares',
	VISUALIZOU_EDICAO_DADOS_PERFIL = 'visualizou_edicao_dados_perfil',
	VISUALIZOU_EDICAO_DADOS_BANCARIOS = 'visualizou_edicao_dados_bancarios',
	CLICK_LER_MAIS_INFOS_SOLICITACAO = 'click_ler_mais_infos_solicitacao',
	CLICK_TIPO_ATENDIMENTO_CONSULTA = 'click_tipo_atendimento_consulta',
	CLICK_TIPO_ATENDIMENTO_EXAMES_SIMPLES = 'click_tipo_atendimento_exames_simples',
	CLICK_TIPO_ATENDIMENTO_EXAMES_ESPECIAIS = 'click_tipo_atendimento_exames_especiais',
	CLICK_TIPO_ATENDIMENTO_INTERNACAO = 'click_tipo_atendimento_internacao',
	CLICK_TIPO_ATENDIMENTO_PRONTO_SOCORRO = 'click_tipo_atendimento_pronto_socorro',
	CLICK_TIPO_ATENDIMENTO_TERAPIAS = 'click_tipo_atendimento_terapias',
	CLICK_LABEL_PESSOA_FISICA = 'click_label_pessoa_fisica',
	CLICK_LABEL_PESSOA_JURIDICA = 'click_label_pessoa_juridica',
	CLICK_PESQUISAR_MEDICO_POR_CPF = 'click_pesquisar_medico_por_cpf',
	CLICK_PESQUISAR_MEDICO_POR_NUMERO_CONSELHO = 'click_pesquisar_medico_por_numero_conselho',
	VISUALIZOU_MEDICO_NAO_REGISTRADO = 'visualizou_medico_nao_registrado',
	CLICK_FINALIZAR_SOLICITACAO = 'click_finalizar_solicitacao',
	VISUALIZOU_MODAL_DE_ERRO_AO_ENVIAR = 'visualizou_modal_de_erro_ao_enviar',
	CLICK_FECHAR_MODAL_DE_ERRO = 'click_fechar_modal_de_erro',
	CLICK_VOLTAR_PARA_TELA_INICIAL = 'click_voltar_para_tela_inicial',
	CLICK_TENTAR_NOVAMENTE = 'click_tentar_novamente',
	CLICK_CONTINUAR_SOLICITAR_PREVIA_REEMBOLSO = 'click_continuar_solicitar_previa_reembolso',
	CLICK_MODALIDADE_PREVIA_TERAPIAS = 'click_modalidade_previa_terapias',
	CLICK_MODALIDADE_PREVIA_INTERNACOES = 'click_modalidade_previa_internacoes',
	CLICK_PROSSEGUIR_PARA_ANEXOS_PREVIA_REEMBOLSO = 'click_prosseguir_para_anexos_previa_reembolso',
	ADICIONOU_ARQUIVO_PREVIA_REEMBOLSO = 'adicionou_arquivo_previa_reembolso_',
	CLICK_ADICIONAR_ARQUIVO_PREVIA_REEMBOLSO = 'click_adicionar_arquivo_previa_reembolso',
	CLICK_PROSSEGUIR_PARA_REVISAO_PREVIA_REEMBOLSO = 'click_prosseguir_para_revisao_previa_reembolso',
	CLICK_FINALIZAR_SOLICITACAO_PREVIA_REEMBOLSO = 'click_finalizar_solicitacao_previa_reembolso',
	CLICK_VOLTAR_STEP_PREVIA_REEMBOLSO = 'click_voltar_step_previa_reembolso',
	CLICK_FECHAR_PREVIA_REEMBOLSO = 'click_fechar_previa_reembolso',
	CLICK_CONSULTAR_REEMBOLSO = 'click_consultar_reembolso',
	CLICK_ENVIO_DE_DOCS_COMPLEMENTARES_REEMBOLSO = 'click_envio_de_docs_complementares_reembolso',
	ERRO_AO_PROSSEGUIR_COM_SOLICITACAO_REEMBOLSO = 'erro_ao_prosseguir_com_solicitacao_reembolso',
	ERRO_AO_CARREGAR_PAGINA_REEMBOLSO = 'erro_ao_carregar_pagina_reembolso',
	VISUALIZOU_MODAL_ABANDONO_REEMBOLSO = 'visualizou_modal_abandono_reembolso',
	CLICK_FECHAR_ICONE_MODAL_ABANDONO_REEMBOLSO = 'click_fechar_icone_modal_abandono_reembolso',
	CLICK_CONFIRMAR_BOTAO_MODAL_ABANDONO_REEMBOLSO = 'click_confirmar_botao_modal_abandono_reembolso',
	CLICK_VOLTAR_MODAL_ABANDONO_REEMBOLSO = 'click_voltar_modal_abandono_reembolso',
	ERRO_ADICIONE_UM_ARQUIVO_REEMBOLSO = 'erro_adicione_um_arquivo_reembolso',
	CLICK_VOLTAR_PARAR_REVISAO_REEMBOLSO = 'click_voltar_parar_revisao_reembolso',
	VISUALIZOU_MODAL_TIPO_ATENDIMENTO = 'visualizou_modal_tipo_atendimento',
	CLICK_FECHAR_MODAL_TIPO_ATENDIMENTO = 'click_fechar_modal_tipo_atendimento',
	CLICK_VOLTAR_PARA_REVISAO_REEMBOLSO = 'click_voltar_para_revisao_reembolso',
	CLICK_PROSSEGUIR_NOVA_SOLICITACAO_REEMBOLSO = 'click_prosseguir_nova_solicitacao_reembolso',
	CLICK_VER_MAIS_CONSULTAR_REEMBOLSO = 'click_ver_mais_consultar_reembolso',
	CLICK_DOWNLOAD_DEMONSTRATIVO_REEMBOLSO = 'click_download_demonstrativo_reembolso',
	CLICK_FECHAR_CONSULTAR_REEMBOLSO = 'click_fechar_consultar_reembolso',
	CLICK_VOLTAR_CONSULTAR_REEMBOLSO = 'click_voltar_consultar_reembolso',
	CLICK_BOTAO_FECHAR_TRILHA_CONSULTAR_REEMBOLSO = 'click_botao_fechar_trilha_consultar_reembolso',
	CLICK_ICONE_FECHAR_TRILHA_CONSULTAR_REEMBOLSO = 'click_icone_fechar_trilha_consultar_reembolso',
	VISUALIZOU_MODAL_ABANDONO_PREVIA_REEMBOLSO = 'visualizou_modal_abandono_previa_reembolso',
	CLICK_FECHAR_ICONE_MODAL_ABANDONO_PREVIA_REEMBOLSO = 'click_fechar_icone_modal_abandono_previa_reembolso',
	CLICK_CONFIRMAR_BOTAO_MODAL_ABANDONO_PREVIA_REEMBOLSO = 'click_confirmar_botao_modal_abandono_previa_reembolso',
	CLICK_VOLTAR_MODAL_ABANDONO_PREVIA_REEMBOLSO = 'click_voltar_modal_abandono_previa_reembolso',
	CLICK_CADASTRAR_NOVA_TERAPIA_REEMBOLSO = 'click_cadastrar_nova_terapia_reembolso',
}

enum ExternalServicesTaggingEnum {
	CLICK_DOCS_E_FORMS = 'click_docs_e_forms',
	CLICK_CARTA_PERMANENCIA = 'click_carta_permanencia',
	CLICK_CARTA_DE_PORTABILIDADE = 'click_carta_de_portabilidade',
	CLICK_DEMONSTRATIVO_DE_QUITACAO_DE_DEBITOS = 'click_demonstrativo_de_quitacao_de_debitos',
	CLICK_PIN_SS = 'click_pin_ss',
	CLICK_REDE_PROPRIA = 'click_rede_propria',
	CLICK_CLUBE_DE_VANTAGENS = 'click_clube_de_vantagens',
	CLICK_MUDANCA_DE_PLANO = 'click_mudanca_de_plano',
	CLICK_ADAPTACAO_DE_CONTRATOS = 'click_adaptacao_de_contratos',
	CLICK_ALTERACAO_CADASTRAL = 'click_alteracao_cadastral',
	CLICK_INCLUSAO_DE_DEPENDENTES = 'click_inclusao_de_dependentes',
	CLICK_REATIVACAO_DE_CONTRATO_CANCELADO_POR_INADIMPLENCIA = 'click_reativacao_de_contrato_cancelado_por_inadimplencia',
	CLICK_MUDAR_TITULAR_DO_PLANO = 'click_mudar_titular_do_plano',
	CLICK_ADESAO_AO_PAD = 'click_adesao_ao_pad',
	CLICK_MINHA_INTERNACAO = 'click_minha_internacao',
	CLICK_OUVIDORIA = 'click_ouvidoria',
	CLICK_GUIA_MEDICO = 'click_guia_medico',
	CLICK_GUIA_ODONTO = 'click_guia_odonto',
	CLICK_REEMBOLSO_ODONTO = 'click_reembolso_odonto',
	CLICK_TABELA_FRANQUIAS = 'click_tabela_franquias',
	CLICK_BOLETOS = 'click_boletos',
	CLICK_DECLARACOES_DOCUMENTOS = 'click_declaracoes_documentos',
	CLICK_COBERTURAS_ADICIONAIS = 'click_coberturas_adicionais',
	CLICK_QUEM_INDICA = 'click_quem_indica',
	CLICK_TOKEN = 'click_token',
	CLICK_CUIDAE = 'click_cuidae',
	CLICK_NOTAS_FISCAIS = 'click_notas_fiscais',
	CLICK_ATENDIMENTO_FINANCEIRO_WHATSAPP = 'click_atendimento_financeiro_whatsapp',
}

enum LoginEnum {
	CLICK_ACESSAR_CONTA = 'click_acessar_conta',
	CLICK_ESQUECI_MINHA_SENHA = 'click_esqueci_minha_senha',
	CLICK_FAZER_CADASTRO = 'click_fazer_cadastro',
	CLICK_ENTENDI_ESQUECI_MINHA_SENHA = 'click_entendi_esqueci_minha_senha',
	CLICK_PRECISO_DE_AJUDA_MODAL = 'click_preciso_de_ajuda_modal',
	CLICK_VALIDAR_CODIGO = 'click_validar_codigo',
	CLICK_REENVIAR_CODIGO = 'click_reenviar_codigo',
	CLICK_PRECISO_DE_AJUDA_PAGINA = 'click_preciso_de_ajuda_pagina',
	CLICK_ACESSAR_MANUAL_ESQUECI_MINHA_SENHA = 'click_acessar_manual_esqueci_minha_senha',
	CLICK_FINALIZAR_ESQUECI_MINHA_SENHA = 'click_finalizar_esqueci_minha_senha',
	CLICK_VOLTAR_ESQUECI_MINHA_SENHA = 'click_voltar_esqueci_minha_senha',
	ERRO_LOGIN = 'erro_login',
	CLICK_SIMULE_SEU_PLANO = 'click_simule_seu_plano',
	CLICK_ACESSAR_MANUAL = 'click_acessar_manual',
}

enum BillsTaggingEnum {
	CLICK_VISUALIZAR_BOLETOS_PAGOS = 'click_visualizar_boletos_pagos',
	CLICK_ADESAO_BOLETO = 'click_adesao_boleto',
	CLICK_COPIAR_CODIGO_BOLETO_PAGINA_INICIAL = 'click_copiar_codigo_boleto_pagina_inicial',
	CLICK_VER_DETALHES_BOLETO = 'click_ver_detalhes_boleto',
	CLICK_VOLTAR_PAGINA_BOLETO = 'click_voltar_pagina_boleto',
	CLICK_SAIBA_MAIS_QUEM_INDICA_BOLETO = 'click_saiba_mais_quem_indica_boleto',
	CLICK_BAIXAR_PDF_BOLETO = 'click_baixar_pdf_boleto',
	CLICK_COPIAR_CODIGO_BOLETO = 'click_copiar_codigo_boleto',
	CLICK_FALAR_COM_ATENDIMENTO_BOLETO_PAGINA_INICIAL = 'click_falar_com_atendimento_boleto_pagina_inicial',
	VISUALIZOU_ALERTA_CENTRAL_BOLETO = 'visualizou_alerta_central_boleto',
	CLICK_FALAR_COM_ATENDIMENTO_BOLETO = 'click_falar_com_atendimento_boleto',
	CLICK_CONFIRMAR_ADESAO_BOLETO = 'click_confirmar_adesao_boleto',
	CLICK_CANCELAR_ADESAO_BOLETO = 'click_cancelar_adesao_boleto',
	CLICK_FECHAR_MODAL_ADESAO_BOLETO = 'click_fechar_modal_adesao_boleto',
	VISUALIZOU_MODAL_ADESAO_BOLETO = 'visualizou_modal_adesao_boleto',
	CLICK_SAIBA_MAIS_ADESAO_BOLETO = 'click_saiba_mais_adesao_boleto',
	VISUALIZOU_MODAL_SAIBA_MAIS_ADESAO_BOLETO = 'visualizou_modal_saiba_mais_adesao_boleto',
	CLICK_FECHAR_MODAL_SAIBA_MAIS_ADESAO_BOLETO = 'click_fechar_modal_saiba_mais_adesao_boleto',
	CLICK_ENTENDI_MODAL_SAIBA_MAIS_ADESAO_BOLETO = 'click_entendi_modal_saiba_mais_adesao_boleto',
	CLICK_SAIBA_MAIS_ALERTA_ATRASO_BOLETO = 'click_saiba_mais_alerta_atraso_boleto',
	CLICK_FECHAR_DRAWER_ALERTA_ATRASO_BOLETO = 'click_fechar_drawer_alerta_atraso_boleto',
	CLICK_ENTENDI_DRAWER_ALERTA_ATRASO_BOLETO = 'click_entendi_drawer_alerta_atraso_boleto',
	CLICK_COPIAR_TELEFONE_ATENDIMENTO_BOLETO = 'click_copiar_telefone_atendimento_boleto',
	CLICK_VOLTAR_DETALHES_BOLETO = 'click_voltar_detalhes_boleto',
	VISUALIZOU_MODAL_BOLETO_ANTIGO_PENDENTE = 'visualizou_modal_boleto_antigo_pendente',
	CLICK_FECHAR_MODAL_BOLETO_ANTIGO_PENDENTE = 'click_fechar_modal_boleto_antigo_pendente',
	CLICK_IR_PARA_BOLETO_MAIS_ANTIGO_PENDENTE = 'click_ir_para_boleto_mais_antigo_pendente',
	CLICK_CONTINUAR_DETALHES_DO_BOLETO_MAIS_ATUAL = 'click_continuar_detalhes_do_boleto_mais_atual',
	VISUALIZOU_MODAL_CONCLUSAO_ADESAO_BOLETO_DIGITAL = 'visualizou_modal_conclusao_adesao_boleto_digital',
	CLICK_FECHAR_MODAL_CONCLUSAO_ADESAO_BOLETO_DIGITAL = 'click_fechar_modal_conclusao_adesao_boleto_digital',
	CLICK_ENTENDI_MODAL_CONCLUSAO_ADESAO_BOLETO_DIGITAL = 'click_entendi_modal_conclusao_adesao_boleto_digital',
	CLICK_COPIAR_CODIGO_BOLETO_SAO_LUCAS = 'click_copiar_codigo_boleto_sao_lucas',
	CLICK_VER_DETALHES_BOLETO_SAO_LUCAS = 'click_ver_detalhes_boleto_sao_lucas',
	CLICK_BAIXAR_PDF_BOLETO_SAO_LUCAS = 'click_baixar_pdf_boleto_sao_lucas',
	CLICK_VOLTAR_DETALHES_BOLETO_SAO_LUCAS = 'click_voltar_detalhes_boleto_sao_lucas',
	CLICK_BAIXAR_EXTRATO_COPARTICIPACAO_SAO_LUCAS = 'click_baixar_extrato_coparticipacao_sao_lucas',

	VISUALIZOU_TOAST_SUCESSO_DOWNLOAD_COPARTICIPACAO_SAO_LUCAS = 'visualizou_toast_sucesso_download_coparticipacao_sao_lucas',
	VISUALIZOU_DRAWER_ADESAO_BOLETO_HOME = 'visualizou_drawer_adesao_boleto_home',
	CLICK_RECEBER_BOLETO_EMAIL_HOME_DRAWER = 'click_receber_boleto_email_home_drawer',
	CLICK_VER_MAIS_TARDE_HOME_DRAWER = 'click_ver_mais_tarde_home_drawer',
	CLICK_FECHAR_DRAWER_ADESAO_BOLETO_HOME = 'click_fechar_drawer_adesao_boleto_home',
	CLICK_NAO_MOSTRAR_90_DIAS_HOME_DRAWER = 'click_nao_mostrar_90_dias_home_drawer',
}

enum WellBornTaggingEnum {
	CLICK_NAO_ESTOU_GRAVIDA = 'click_nao_estou_gravida',
	CLICK_ESTOU_GRAVIDA = 'click_estou_gravida',
	CLICK_NAO_TENHO_INTERESSE = 'click_nao_tenho_interesse',
	CLICK_QUERO_ME_INSCREVER = 'click_quero_me_inscrever',
	ENTROU_NO_FLUXO_NASCER_OU_GESTAR_BEM = 'entrou_no_fluxo_nascer_ou_gestar_bem',
	VISUALIZOU_CARD_DE_INSCRICAO_NASCER_BEM = 'visualizou_card_de_inscricao_nascer_bem',
	CLICK_CONTINUAR_PARA_AGENDAMENTO = 'click_continuar_para_agendamento',
	VISUALIZOU_CARD_DE_RECUSA = 'visualizou_card_de_recusa',
	CLICK_AGENDAR_GINECOLOGIA_CLINICA = 'click_agendar_ginecologia_clinica',
	VISUALIZOU_CARD_QUERO_ME_INSCREVER_APOS_RECUSA = 'visualizou_card_quero_me_inscrever_apos_recusa',
	CLICK_QUERO_ME_INSCREVER_APOS_RECUSA = 'click_quero_me_inscrever_apos_recusa',
	CLICK_FALAR_COM_ATENDIMENTO_NASCER_BEM = 'click_falar_com_atendimento_nascer_bem',
	CLICK_EXIBIR_TELEFONES_NASCER_BEM = 'click_exibir_telefones_nascer_bem',
	VISUALIZOU_CARD_DE_INSCRICAO_GESTAR_BEM = 'visualizou_card_de_inscricao_gestar_bem',
	CLICK_FALAR_COM_ATENDIMENTO_NASCER_BEM_REMARCACAO = 'click_falar_com_atendimento_nascer_bem_remarcacao',
	CLICK_EXIBIR_TELEFONES_NASCER_BEM_REMARCACAO = 'click_exibir_telefones_nascer_bem_remarcacao',
}

enum ConsultProtocolsTaggingEnum {
	CLICK_FILTRAR_CONSULTA_PROTOCOLOS = 'click_filtrar_consulta_protocolos',
	CLICK_FILTRO_ORDENACAO_MAIS_RECENTE = 'click_filtro_mais_recente',
	CLICK_FILTRO_ORDENACAO_MAIS_ANTIGO = 'click_filtro_mais_antigo',
	CLICK_FILTRO_TIPO_TODOS = 'click_filtro_todos',
	CLICK_FILTRO_TIPO = 'click_filtro_tipo_',
	CLICK_FILTRO_STATUS_TODOS = 'click_filtro_status_todos',
	CLICK_FILTRO_STATUS = 'click_filtro_status_',
	CLICK_LIMPAR_FILTRO_CONSULTA_PROTOCOLOS = 'click_limpar_filtro_consulta_protocolos',
	CLICK_APLICAR_FILTRO_CONSULTA_PROTOCOLOS = 'click_aplicar_filtro_consulta_protocolos',
	CLICK_BOTAO_FECHAR_FILTRO_CONSULTA_PROTOCOLOS = 'click_botao_fechar_filtro_consulta_protocolos',
	CLICK_VER_MAIS_PROTOCOLO_LISTA_PROTOCOLOS = 'click_ver_mais_protocolo_lista_protocolos',
	CLICK_BOTAO_FECHAR_DRAWER_CONSULTA_PROTOCOLOS = 'click_botao_fechar_drawer_consulta_protocolos',
	CLICK_ICONE_FECHAR_DRAWER_CONSULTA_PROTOCOLOS = 'click_icone_fechar_drawer_consulta_protocolos',
	CLICK_ALTERAR_INTERVALO_DATA_CONSULTA_PROTOCOLOS = 'click_alterar_intervalo_data_consulta_protocolos',
	CLICK_VOLTAR_CONSULTA_PROTOCOLOS = 'click_voltar_consulta_protocolos',
}

enum ConfirmationDrawerEnum {
	CLICK_FECHAR_CONFIRMACAO_DADOS = 'click_fechar_confirmacao_dados_',
	CLICK_ALTERAR_PLANO_CONFIRMACAO_DADOS = 'click_alterar_plano_confirmacao_dados',
	CLICK_ALTERAR_DADOS_PESSOAIS_CONFIRMACAO_DADOS = 'click_alterar_dados_pessoais_confirmacao_dados_',
}

enum OdontoBookingTaggingEnum {
	CLICK_ALTERAR_LOCAL_DE_ATENDIMENTO = 'click_alterar_local_de_atendimento_',
	CLICK_SELECIONAR_MANUALMENTE_LOCALIZACAO_DESATIVADA = 'click_selecionar_manualmente_localizacao_desativada_',
	CLICK_NAO_ENCONTREI_ESPECIALIDADE_DESEJADA = 'click_nao_encontrei_especialidade_desejada_',
	VISUALIZOU_MODAL_NAO_ENCONTREI_ESPECIALIDADE_DESEJADA = 'visualizou_modal_nao_encontrei_especialidade_desejada_',
	CLICK_FECHAR_MODAL_NAO_ENCONTREI_ESPECIALIDADE_DESEJADA = 'click_fechar_modal_nao_encontrei_especialidade_desejada_',
	CLICK_CONSULTAR_REDE_ATENDIMENTO = 'click_consultar_rede_atendimento_',
	CLICK_CONSULTAR_REDE_ATENDIMENTO_ODONTO = 'click_consultar_rede_atendimento_odonto',
	CLICK_FALAR_COM_ATENDIMENTO_ONLINE = 'click_falar_com_atendimento_online_',
	CLICK_NAO_ENCONTREI_BAIRRO_DESEJADO_ODONTO = 'click_nao_encontrei_bairro_desejado_odonto',
	VISUALIZOU_MODAL_NAO_ENCONTREI_BAIRRO_DESEJADO_ODONTO = 'visualizou_modal_nao_encontrei_bairro_desejado_odonto',
	CLICK_FECHAR_MODAL_NAO_ENCONTREI_BAIRRO_DESEJADO_ODONTO = 'click_fechar_modal_nao_encontrei_bairro_desejado_odonto',
	CLICK_SELECIONAR_BAIRRO_ODONTO = 'click_selecionar_bairro_odonto',
	CLICK_AVANCAR_SELECAO_BAIRROS_ODONTO = 'click_avancar_selecao_bairros_odonto',
	CLICK_ALTERAR_ESPECIALIDADE = 'click_alterar_especialidade_',
	CLICK_VER_MAPA_REDE_CRED_ODONTO = 'click_ver_mapa_rede_cred_odonto',
	CLICK_VER_DETALHES_REDE_CRED_ODONTO = 'click_ver_detalhes_rede_cred_odonto',
	CLICK_LIGAR_REDE_CRED_ODONTO = 'click_ligar_rede_cred_odonto',
	CLICK_VER_MAPA_DRAWER_REDE_CRED = 'click_ver_mapa_drawer_rede_cred',
	CLICK_ALTERAR_BAIRRO = 'click_alterar_bairro_',
	CLICK_ALTERAR_LOCALIZACAO_SELECIONADA_ODONTO = 'click_alterar_localizacao_selecionada_odonto',
	CLICK_FILTRAR_UNIDADES = 'click_filtrar_unidades',
	CLICK_FILTRAR_UNIDADES_PCD_ODONTO = 'click_filtrar_unidades_pcd_odonto',
	CLICK_APLICAR_FILTRO_UNIDADES_ODONTO = 'click_aplicar_filtro_unidades_odonto',
	CLICK_LIMPAR_FILTRO_UNIDADES_ODONTO = 'click_limpar_filtro_unidades_odonto',
	CLICK_AGENDAR_REDE_PROPRIA_ODONTO = 'click_agendar_rede_propria_odonto',
	ERRO_NAO_FOI_POSSIVEL_LISTAR_UNIDADES = 'erro_nao_foi_possivel_carregar_unidades',
	CLICK_TENTAR_NOVAMENTE_ERRO_UNIDADES = 'click_tentar_novamente_erro_unidades',
	CLICK_VOLTAR_STEP_CONFIRMAR_AGENDAMENTO = 'click_voltar_step_confirmar_agendamento',
	CLICK_VER_COMO_CHEGAR = 'click_ver_como_chegar',
	VISUALIZOU_MODAL_CONFIRMACAO_AGENDAMENTO_ODONTO = 'visualizou_modal_confirmacao_agendamento_odonto',
	CLICK_ENTENDI_MODAL_CONFIRMACAO_AGENDAMENTO = 'click_entendi_modal_confirmacao_agendamento',
	CLICK_VER_MEUS_AGENDAMENTOS = 'click_ver_meus_agendamentos',
	CLICK_SAIBA_MAIS_QUEM_INDICA = 'click_saiba_mais_quem_indica',
	CLICK_BAIXAR_AGENDAMENTO = 'click_baixar_agendamento',
	CLICK_SALVAR_NA_AGENDA = 'click_salvar_na_agenda',
	CLICK_COMPARTILHAR_AGENDAMENTO = 'click_compartilhar_agendamento',
}

enum ExamResultsTaggingEnum {
	CLICK_AGENDAR_EXAME_EMPTY_STATE = 'click_agendar_exame_empty_state_resultado_de_exames',
	CLICK_VER_DETALHES_EXAME = 'click_ver_detalhes_exame_resultado_de_exames',
	CLICK_BAIXAR_LAUDO_EXAME = 'click_baixar_laudo_exame_resultado_de_exames',
	CLICK_VOLTAR_RESULTADO_DE_EXAMES = 'click_voltar_resultado_de_exames',
	CLICK_COMPARTILHAR_RESULTADO_DE_EXAMES = 'click_compartilhar_resultado_de_exames',
	CLICK_FILTRAR_DATA_RESULTADO_DE_EXAMES = 'click_filtrar_data_resultado_de_exames',
	CLICK_LIMPAR_FILTRO_RESULTADO_DE_EXAMES = 'click_limpar_filtro_resultado_de_exames',
	VISUALIZOU_EMPTY_STATE_AGUARDANDO_LIBERACAO = 'visualizou_empty_state_aguardando_liberacao_resultado_de_exames',
	VISUALIZOU_EMPTY_STATE_LIBERADOS = 'visualizou_empty_state_liberados_resultado_de_exames',
	VISUALIZOU_ERROR_STATE_AGUARDANDO_LIBERACAO = 'visualizou_error_state_aguardando_liberacao_resultado_de_exames',
	VISUALIZOU_ERROR_STATE_LIBERADOS = 'visualizou_error_state_liberados_resultado_de_exames',
	CLICK_FILTRAR_LIBERADOS = 'click_filtrar_liberados_resultado_de_exames',
	CLICK_FILTRAR_AGUARDANDO_LIBERACAO = 'click_filtrar_aguardando_liberacao_resultado_de_exames',
	VISUALIZOU_LISTA_LIBERADOS = 'visualizou_lista_liberados_resultado_de_exames',
	VISUALIZOU_LISTA_AGUARDANDO_LIBERACAO = 'visualizou_lista_aguardando_liberacao_resultado_de_exames',
	CLICK_FILTRAR_TODOS_TIPOS_EXAMES = 'click_filtrar_todos_tipos_exames_resultado_de_exames',
	CLICK_FILTRAR_EXAME_DE_IMAGEM = 'click_filtrar_exame_de_imagem_resultado_de_exames',
	CLICK_FILTRAR_EXAME_LABORATORIAL = 'click_filtrar_exame_laboratorial_resultado_de_exames',
	CLICK_FILTRAR_EXAME_LABORATORIAL_E_IMAGEM = 'click_filtrar_exame_laboratorial_e_imagem_resultado_de_exames',
	CLICK_APLICAR_FILTRO_TIPO_EXAMES_LIBERADOS = 'click_aplicar_filtro_tipo_exames_liberados_resultado_de_exames',
	CLICK_APLICAR_FILTRO_TIPO_EXAMES_AGUARDANDO_LIBERACAO = 'click_aplicar_filtro_tipo_exames_aguardando_liberacao_resultado_de_exames',
	CLICK_LIMPAR_FILTRO_RESULTADO_DE_EXAMES_LIBERADOS = 'click_limpar_filtro_resultado_de_exames_liberados',
	CLICK_LIMPAR_FILTRO_RESULTADO_DE_EXAMES_AGUARDANDO_LIBERACAO = 'click_limpar_filtro_resultado_de_exames_aguardando_liberacao',
	CLICK_FECHAR_FILTRO_RESULTADO_DE_EXAMES_LIBERADOS = 'click_fechar_filtro_resultado_de_exames_liberados',
	CLICK_FECHAR_FILTRO_RESULTADO_DE_EXAMES_AGUARDANDO_LIBERACAO = 'click_fechar_filtro_resultado_de_exames_aguardando_liberacao',
	CLICK_DETALHES_EXAMES_LIBERADOS = 'click_detalhes_exames_liberados_resultado_de_exames',
	CLICK_DETALHES_EXAMES_AGUARDANDO_LIBERACAO = 'click_detalhes_exames_aguardando_liberacao_resultado_de_exames',
	CLICK_COMPARTILHAR_RESULTADO_DE_EXAMES_LIBERADOS = 'click_compartilhar_resultado_de_exames_liberados',
	CLICK_COMPARTILHAR_RESULTADO_DE_EXAMES_AGUARDANDO_LIBERACAO = 'click_compartilhar_resultado_de_exames_aguardando_liberacao_resultado_de_exames',
	CLICK_BAIXAR_LAUDO_EXAME_LIBERADOS = 'click_baixar_laudo_exame_liberados_resultado_de_exames',
	CLICK_FECHAR_DRAWER_EXAMES_AGUARDANDO_LIBERACAO = 'click_fechar_drawer_exames_aguardando_liberacao_resultado_de_exames',
	VISUALIZOU_SNACKBAR_ERRO_AO_BAIXAR_LAUDO = 'visualizou_snackbar_erro_ao_baixar_laudo_resultado_de_exames',
	CLICK_VER_IMAGEM_EXAME = 'click_ver_imagem_exame_resultado_de_exames',
	CLICK_FECHAR_DRAWER_RESULTADO_EXAME = 'click_fechar_drawer_resultado_exame_resultado_de_exames',
}

enum HomeActionsEnum {
	CLICK_VER_TODOS_MENU_PRINCIPAL = 'click_ver_todos_menu_principal',
}

enum PerksTaggingEnum {
	CLICK_VOLTAR_BENEFICIOS = 'click_voltar_beneficios',
	CLICK_COBERTURAS_ADICIONAIS_BENEFICIOS = 'click_coberturas_adicionais_beneficios',
	CLICK_CLUBE_DE_VANTAGENS_BENEFICIOS = 'click_clube_de_vantagens_beneficios',
	CLICK_QUEM_INDICA_BENEFICIOS = 'click_quem_indica_beneficios',
	CLICK_CONTRATE_ONLINE_BENEFICIOS = 'click_contrate_online_beneficios',
}

enum HelpPageTaggingEnum {
	CLICK_ACESSAR_AJUDA = 'click_acessar_ajuda',
	CLICK_VOLTAR_AJUDA = 'click_voltar_ajuda',
	CLICK_DUVIDAS_FREQUENTES_AJUDA = 'click_duvidas_frequentes_ajuda',
	CLICK_MANDE_SUA_MENSAGEM_AJUDA = 'click_mande_sua_mensagem_ajuda',
	CLICK_POSSO_AJUDAR_AJUDA = 'click_posso_ajudar_ajuda',
	CLICK_CANAL_DELAS_AJUDA = 'click_canal_delas_ajuda',
	CLICK_EXPANDIR_TELEFONE_CALL_CENTER_AJUDA = 'click_expandir_telefone_call_center_ajuda',
	CLICK_EXPANDIR_TELEFONE_MARCACAO_AJUDA = 'click_expandir_telefone_marcacao_ajuda',
	CLICK_EXPANDIR_TELEFONE_SAC_AJUDA = 'click_expandir_telefone_sac_ajuda',
	CLICK_EXPANDIR_TELEFONE_OUVIDORIA_AJUDA = 'click_expandir_telefone_ouvidoria_ajuda',
	CLICK_EXPANDIR_CENTRAL_CANCELAMENTO_SAUDE_AJUDA = 'click_expandir_central_cancelamento_saude_ajuda',
	CLICK_EXPANDIR_CENTRAL_VENDAS_SAUDE_AJUDA = 'click_expandir_central_vendas_saude_ajuda',
	CLICK_EXPANDIR_CENTRAL_SERVICOS_AJUDA = 'click_expandir_central_servicos_ajuda',
	CLICK_EXPANDIR_ATENDIMENTO_FINANCEIRO_AJUDA = 'click_expandir_atendimento_financeiro_ajuda',
}

enum MyReferralsTaggingEnum {
	CLICK_ACESSAR_MEUS_ENCAMINHAMENTOS_MENU = 'click_acessar_meus_encaminhamentos_menu',
	CLICK_ACESSAR_MEUS_ENCAMINHAMENTOS_CARD = 'click_acessar_meus_encaminhamentos_card',
	CLICK_VOLTAR_MEUS_ENCAMINHAMENTOS = 'click_voltar_meus_encaminhamentos',
	CLICK_FECHAR_MEUS_ENCAMINHAMENTOS = 'click_fechar_meus_encaminhamentos',
	CLICK_ABA_EM_ANDAMENTO_MEUS_ENCAMINHAMENTOS = 'click_aba_em_andamento_meus_encaminhamentos',
	CLICK_ABA_HISTORICO_MEUS_ENCAMINHAMENTOS = 'click_aba_historico_meus_encaminhamentos',
	CLICK_VER_DETALHES_MEUS_ENCAMINHAMENTOS = 'click_ver_detalhes_meus_encaminhamentos',
	CLICK_FECHAR_VER_DETALHES_MEUS_ENCAMINHAMENTOS = 'click_fechar_ver_detalhes_meus_encaminhamentos',
	CLICK_COPIAR_SENHA_LIBERADO_MEUS_ENCAMINHAMENTOS = 'click_copiar_senha_liberado_meus_encaminhamentos',
	CLICK_COPIAR_TELEFONE_LIBERADO_MEUS_ENCAMINHAMENTOS = 'click_copiar_telefone_liberado_meus_encaminhamentos',
	CLICK_LIGAR_LIBERADO_MEUS_ENCAMINHAMENTOS = 'click_ligar_liberado_meus_encaminhamentos',
	CLICK_VER_MAPA_LIBERADO_MEUS_ENCAMINHAMENTOS = 'click_ver_mapa_liberado_meus_encaminhamentos',
	CLICK_AGENDAR_MEUS_ENCAMINHAMENTOS = 'click_agendar_meus_encaminhamentos',
	CLICK_VER_AGENDAMENTO_MEUS_ENCAMINHAMENTOS = 'click_ver_agendamento_meus_encaminhamentos',
	CLICK_IR_PARA_AUTORIZACAO_EM_ANDAMENTO_MEUS_ENCAMINHAMENTOS = 'click_ir_para_autorizacao_em_andamento_meus_encaminhamentos',
	CLICK_IR_PARA_AUTORIZACAO_HISTORICO_MEUS_ENCAMINHAMENTOS = 'click_ir_para_autorizacao_historico_meus_encaminhamentos',
	CLICK_FILTRO_DATA_EM_ANDAMENTO_MEUS_ENCAMINHAMENTOS = 'click_filtro_data_em_andamento_meus_encaminhamentos',
	CLICK_APLICAR_FILTRO_DATA_EM_ANDAMENTO_MEUS_ENCAMINHAMENTOS = 'click_aplicar_filtro_data_em_andamento_meus_encaminhamentos',
	CLICK_LIMPAR_FILTRO_DATA_EM_ANDAMENTO_MEUS_ENCAMINHAMENTOS = 'click_limpar_filtro_data_em_andamento_meus_encaminhamentos',
	CLICK_FECHAR_FILTRO_DATA_EM_ANDAMENTO_MEUS_ENCAMINHAMENTOS = 'click_fechar_filtro_data_em_andamento_meus_encaminhamentos',
	CLICK_FILTRO_DATA_HISTORICO_MEUS_ENCAMINHAMENTOS = 'click_filtro_data_historico_meus_encaminhamentos',
	CLICK_LIMPAR_FILTRO_DATA_HISTORICO_MEUS_ENCAMINHAMENTOS = 'click_limpar_filtro_data_historico_meus_encaminhamentos',
	CLICK_APLICAR_FILTRO_DATA_HISTORICO_MEUS_ENCAMINHAMENTOS = 'click_aplicar_filtro_data_historico_meus_encaminhamentos',
	CLICK_FECHAR_FILTRO_DATA_HISTORICO_MEUS_ENCAMINHAMENTOS = 'click_fechar_filtro_data_historico_meus_encaminhamentos',
	CLICK_BUSCAR_ENCAMINHAMENTO_EM_ANDAMENTO_MEUS_ENCAMINHAMENTOS = 'click_buscar_encaminhamento_em_andamento_meus_encaminhamentos',
	CLICK_BUSCAR_ENCAMINHAMENTO_HISTORICO_MEUS_ENCAMINHAMENTOS = 'click_buscar_encaminhamento_historico_meus_encaminhamentos',
	CLICK_FILTRO_EM_ANDAMENTO_MEUS_ENCAMINHAMENTOS = 'click_filtro_em_andamento_meus_encaminhamentos',
	CLICK_LIMPAR_FILTRO_EM_ANDAMENTO_MEUS_ENCAMINHAMENTOS = 'click_limpar_filtro_em_andamento_meus_encaminhamentos',
	CLICK_LIMPAR_FILTRO_HISTORICO_MEUS_ENCAMINHAMENTOS = 'click_limpar_filtro_historico_meus_encaminhamentos',
	CLICK_APLICAR_FILTRO_EM_ANDAMENTO_MEUS_ENCAMINHAMENTOS = 'click_aplicar_filtro_em_andamento_meus_encaminhamentos',
	CLICK_APLICAR_FILTRO_HISTORICO_MEUS_ENCAMINHAMENTOS = 'click_aplicar_filtro_historico_meus_encaminhamentos',
	CLICK_FECHAR_FILTRO_EM_ANDAMENTO_MEUS_ENCAMINHAMENTOS = 'click_fechar_filtro_em_andamento_meus_encaminhamentos',
	CLICK_FECHAR_FILTRO_HISTORICO_MEUS_ENCAMINHAMENTOS = 'click_fechar_filtro_historico_meus_encaminhamentos',
	CLICK_FILTRO_HISTORICO_MEUS_ENCAMINHAMENTOS = 'click_filtro_historico_meus_encaminhamentos',
	CLICK_FILTRO_TIPO_PROCEDIMENTO_TODOS_EM_ANDAMENTO_MEUS_ENCAMINHAMENTOS = 'click_filtro_tipo_procedimento_todos_em_andamento_meus_encaminhamentos',
	CLICK_FILTRO_TIPO_PROCEDIMENTO_CONSULTA_EM_ANDAMENTO_MEUS_ENCAMINHAMENTOS = 'click_filtro_tipo_procedimento_consulta_em_andamento_meus_encaminhamentos',
	CLICK_FILTRO_TIPO_PROCEDIMENTO_EXAME_EM_ANDAMENTO_MEUS_ENCAMINHAMENTOS = 'click_filtro_tipo_procedimento_exame_em_andamento_meus_encaminhamentos',
	CLICK_FILTRO_TIPO_PROCEDIMENTO_CIRURGIA_EM_ANDAMENTO_MEUS_ENCAMINHAMENTOS = 'click_filtro_tipo_procedimento_cirurgia_em_andamento_meus_encaminhamentos',
	CLICK_FILTRO_STATUS_TODOS_EM_ANDAMENTO_MEUS_ENCAMINHAMENTOS = 'click_filtro_status_todos_em_andamento_meus_encaminhamentos',
	CLICK_FILTRO_TIPO_PROCEDIMENTO_TODOS_HISTORICO_MEUS_ENCAMINHAMENTOS = 'click_filtro_tipo_procedimento_todos_historico_meus_encaminhamentos',
	CLICK_FILTRO_TIPO_PROCEDIMENTO_CONSULTA_HISTORICO_MEUS_ENCAMINHAMENTOS = 'click_filtro_tipo_procedimento_consulta_historico_meus_encaminhamentos',
	CLICK_FILTRO_TIPO_PROCEDIMENTO_EXAME_HISTORICO_MEUS_ENCAMINHAMENTOS = 'click_filtro_tipo_procedimento_exame_historico_meus_encaminhamentos',
	CLICK_FILTRO_TIPO_PROCEDIMENTO_CIRURGIA_HISTORICO_MEUS_ENCAMINHAMENTOS = 'click_filtro_tipo_procedimento_cirurgia_historico_meus_encaminhamentos',
	CLICK_FILTRO_STATUS_TODOS_HISTORICO_MEUS_ENCAMINHAMENTOS = 'click_filtro_status_todos_historico_meus_encaminhamentos',
	CLICK_FILTRO_STATUS_LIBERADO_MEUS_ENCAMINHAMENTOS = 'click_filtro_status_liberado_meus_encaminhamentos',
	CLICK_FILTRO_STATUS_PENDENTE_MEUS_ENCAMINHAMENTOS = 'click_filtro_status_pendente_meus_encaminhamentos',
	CLICK_FILTRO_STATUS_AGENDADO_MEUS_ENCAMINHAMENTOS = 'click_filtro_status_agendado_meus_encaminhamentos',
	CLICK_FILTRO_STATUS_CONCLUIDO_MEUS_ENCAMINHAMENTOS = 'click_filtro_status_concluido_meus_encaminhamentos',
	CLICK_FILTRO_STATUS_INDEFERIDO_MEUS_ENCAMINHAMENTOS = 'click_filtro_status_indeferido_meus_encaminhamentos',
	CLICK_FILTRO_STATUS_EM_ANALISE_MEUS_ENCAMINHAMENTOS = 'click_filtro_status_em_analise_meus_encaminhamentos',
	CLICK_LIGAR_CIRURGIA_MEUS_ENCAMINHAMENTOS = 'click_ligar_cirurgia_meus_encaminhamentos',
	CLICK_COPIAR_TELEFONE_CIRURGIA_MEUS_ENCAMINHAMENTOS = 'click_copiar_telefone_cirurgia_meus_encaminhamentos',
	CLICK_ICONE_LIGAR_CIRURGIA_MEUS_ENCAMINHAMENTOS = 'click_icone_ligar_cirurgia_meus_encaminhamentos',
	VISUALIZOU_EMPTY_STATE_MEUS_ENCAMINHAMENTOS_EM_ANDAMENTO = 'visualizou_empty_state_meus_encaminhamentos_em_andamento',
	VISUALIZOU_EMPTY_STATE_MEUS_ENCAMINHAMENTOS_HISTORICO = 'visualizou_empty_state_meus_encaminhamentos_historico',
	CLICK_SOLICITAR_AUTORIZACAO_EMPTY_STATE_MEUS_ENCAMINHAMENTOS_EM_ANDAMENTO = 'click_solicitar_autorizacao_empty_state_meus_encaminhamentos_em_andamento',
	CLICK_SOLICITAR_AUTORIZACAO_EMPTY_STATE_MEUS_ENCAMINHAMENTOS_HISTORICO = 'click_solicitar_autorizacao_empty_state_meus_encaminhamentos_historico',
	CLICK_LIMPAR_FILTROS_EMPTY_STATE_MEUS_ENCAMINHAMENTOS_EM_ANDAMENTO = 'click_limpar_filtros_empty_state_meus_encaminhamentos_em_andamento',
	CLICK_LIMPAR_FILTROS_EMPTY_STATE_MEUS_ENCAMINHAMENTOS_HISTORICO = 'click_limpar_filtros_empty_state_meus_encaminhamentos_historico',
	CLICK_LIMPAR_BUSCA_EMPTY_STATE_MEUS_ENCAMINHAMENTOS_EM_ANDAMENTO = 'click_limpar_busca_empty_state_meus_encaminhamentos_em_andamento',
	CLICK_LIMPAR_BUSCA_EMPTY_STATE_MEUS_ENCAMINHAMENTOS_HISTORICO = 'click_limpar_busca_empty_state_meus_encaminhamentos_historico',
}

enum FacialBiometricsTaggingEnum {
	CLICK_CADASTRAR_BIOMETRIA_FACIAL_PERFIL = 'click_cadastrar_biometria_facial_perfil',
	CLICK_CADASTRAR_BIOMETRIA_FACIAL_AVISOS = 'click_cadastrar_biometria_facial_avisos',
	CLICK_CADASTRAR_BIOMETRIA_FACIAL_CARD_TELECONSULTA = 'click_cadastrar_biometria_facial_card_teleconsulta',
	CLICK_CADASTRAR_BIOMETRIA_FACIAL_AGORA = 'click_cadastrar_biometria_facial_agora',
	CLICK_CADASTRAR_BIOMETRIA_FACIAL_DEPOIS = 'click_cadastrar_biometria_facial_depois',
	CLICK_ABANDONAR_CADASTRO_BIOMETRIA_FACIAL = 'click_abandonar_cadastro_biometria_facial',
	CLICK_CANCELAR_AGENDAMENTO_BIOMETRIA_FACIAL = 'click_cancelar_agendamento_biometria_facial',
}

export {
	HomeActionsEnum,
	EmptyEnum,
	CompleteProfileEnum,
	MyProfileEnum,
	SelectionUserPlanEnum,
	GuideFilterEnum,
	AppointmentBookingEnum,
	BookingScheduledEnum,
	BookingScriptFlowEnum,
	BookingProcessSuccessEnum,
	MotorV2Enums,
	FinishWithoutCompleteFlowEnum,
	FiveStarsEnum,
	AutoSolEnum,
	NetworkEnum,
	ServicesTaggingEnum,
	RefundTaggingEnum,
	ExternalServicesTaggingEnum,
	LoginEnum,
	BillsTaggingEnum,
	WellBornTaggingEnum,
	ConsultProtocolsTaggingEnum,
	ExamResultsTaggingEnum,
	ConfirmationDrawerEnum,
	OdontoBookingTaggingEnum,
	PerksTaggingEnum,
	HelpPageTaggingEnum,
	MyReferralsTaggingEnum,
	FacialBiometricsTaggingEnum,
};
